const DEFAULT_PROTOCOL = "https://";
const LOCAL_DEV_PORT = ":8000";
const HOST_QUERY_NAME = "host";
const HOST_QUERY_VALUE = "exp";
const NOCHROME_QUERY_PARAM = "nochrome=true";
const HOST_QUERY_PARAM = `${HOST_QUERY_NAME}=${HOST_QUERY_VALUE}`;
const LOCAL_HOSTNAME = `localhost`;
const BCT_LOCAL_HOSTNAME = "localhost";
const EXP_HOSTNAME = "exp.microsoft.com";
const CT_HOSTNAME = "ct.exp.microsoft.com";
const UI_HOSTNAME = "ui.exp.microsoft.com";
const UI_PPE_HOSTNAME = "ppeui.exp.microsoft.com";
const UI_AZURE_HOSTNAME = "expui-web-prod-wus.azurewebsites.net";
const UI_AZURE_STAGING_HOSTNAME = "expui-web-prod-wus-staging.azurewebsites.net";
const UI_AZURE_DEV_HOSTNAME = "expui-web-prod-wus-dev.azurewebsites.net";
const UI_DEV_HOSTNAME = "expui-web-dev-wus.azurewebsites.net";
const VIVACE_HOSTNAME = "vivace.exp.microsoft.com";
const VIVACE_INT_HOSTNAME = "vivace.int.exp.microsoft.com";
const expui_web_prod_wus_staging_hostname = "expui-web-prod-wus-staging.exp.microsoft.com";
const expui_web_dev_wus_hostname = "expui-web-dev-wus.exp.microsoft.com";
const LOCAL_HOST = `${LOCAL_HOSTNAME}${LOCAL_DEV_PORT}`;
const BCT_LOCAL_HOST = BCT_LOCAL_HOSTNAME;
const EXP_HOST = EXP_HOSTNAME;
const CT_HOST = CT_HOSTNAME;
const UI_HOST = UI_HOSTNAME;
const UI_PPE_HOST = UI_PPE_HOSTNAME;
const UI_AZURE_HOST = UI_AZURE_HOSTNAME;
const UI_AZURE_STAGING_HOST = UI_AZURE_STAGING_HOSTNAME;
const UI_AZURE_DEV_HOST = UI_AZURE_DEV_HOSTNAME;
const UI_DEV_HOST = UI_DEV_HOSTNAME;
const expui_web_prod_wus_staging_host = expui_web_prod_wus_staging_hostname;
const expui_web_dev_wus_host = expui_web_dev_wus_hostname;
const LOCAL_ORIGIN = `${DEFAULT_PROTOCOL}${LOCAL_HOST}`;
const BCT_LOCAL_ORIGIN = `${DEFAULT_PROTOCOL}${BCT_LOCAL_HOST}`;
const EXP_ORIGIN = `${DEFAULT_PROTOCOL}${EXP_HOST}`;
const CT_ORIGIN = `${DEFAULT_PROTOCOL}${CT_HOST}`;
const UI_ORIGIN = `${DEFAULT_PROTOCOL}${UI_HOST}`;
const UI_PPE_ORIGIN = `${DEFAULT_PROTOCOL}${UI_PPE_HOST}`;
const UI_AZURE_ORIGIN = `${DEFAULT_PROTOCOL}${UI_AZURE_HOST}`;
const UI_AZURE_STAGING_ORIGIN = `${DEFAULT_PROTOCOL}${UI_AZURE_STAGING_HOST}`;
const UI_AZURE_DEV_ORIGIN = `${DEFAULT_PROTOCOL}${UI_AZURE_DEV_HOST}`;
const UI_DEV_ORIGIN = `${DEFAULT_PROTOCOL}${UI_DEV_HOST}`;
const expui_web_prod_wus_staging_origin = `${DEFAULT_PROTOCOL}${expui_web_prod_wus_staging_host}`;
const expui_web_dev_wus_origin = `${DEFAULT_PROTOCOL}${expui_web_dev_wus_host}`;
const HOSTNAMES = [
  BCT_LOCAL_ORIGIN,
  LOCAL_HOSTNAME,
  EXP_HOSTNAME,
  CT_HOSTNAME,
  UI_HOSTNAME,
  UI_DEV_HOSTNAME,
  UI_PPE_HOSTNAME,
  expui_web_prod_wus_staging_hostname,
  expui_web_dev_wus_hostname
];
const HOSTS = [
  BCT_LOCAL_ORIGIN,
  LOCAL_ORIGIN,
  EXP_ORIGIN,
  CT_ORIGIN,
  UI_ORIGIN,
  UI_DEV_ORIGIN,
  UI_PPE_ORIGIN,
  expui_web_prod_wus_staging_origin,
  expui_web_dev_wus_origin
];
const UI_ORIGINS = [
  LOCAL_ORIGIN,
  BCT_LOCAL_ORIGIN,
  EXP_ORIGIN,
  CT_ORIGIN,
  UI_ORIGIN,
  UI_AZURE_ORIGIN,
  UI_AZURE_STAGING_ORIGIN,
  UI_AZURE_DEV_ORIGIN,
  UI_DEV_ORIGIN,
  UI_PPE_ORIGIN,
  expui_web_prod_wus_staging_origin,
  expui_web_dev_wus_origin
];
const UI_HOST_ORIGINS = [
  LOCAL_ORIGIN,
  UI_ORIGIN,
  UI_AZURE_ORIGIN,
  UI_AZURE_STAGING_ORIGIN,
  UI_AZURE_DEV_ORIGIN,
  UI_DEV_ORIGIN,
  UI_PPE_ORIGIN,
  expui_web_prod_wus_staging_origin,
  expui_web_dev_wus_origin
];
const BCT_ORIGINS = [BCT_LOCAL_ORIGIN, CT_ORIGIN];
export {
  BCT_LOCAL_HOST,
  BCT_LOCAL_HOSTNAME,
  BCT_LOCAL_ORIGIN,
  BCT_ORIGINS,
  CT_HOST,
  CT_HOSTNAME,
  CT_ORIGIN,
  DEFAULT_PROTOCOL,
  EXP_HOST,
  EXP_HOSTNAME,
  EXP_ORIGIN,
  HOSTNAMES,
  HOSTS,
  HOST_QUERY_NAME,
  HOST_QUERY_PARAM,
  HOST_QUERY_VALUE,
  LOCAL_DEV_PORT,
  LOCAL_HOST,
  LOCAL_HOSTNAME,
  LOCAL_ORIGIN,
  NOCHROME_QUERY_PARAM,
  UI_AZURE_DEV_HOST,
  UI_AZURE_DEV_HOSTNAME,
  UI_AZURE_DEV_ORIGIN,
  UI_AZURE_HOST,
  UI_AZURE_HOSTNAME,
  UI_AZURE_ORIGIN,
  UI_AZURE_STAGING_HOST,
  UI_AZURE_STAGING_HOSTNAME,
  UI_AZURE_STAGING_ORIGIN,
  UI_DEV_HOST,
  UI_DEV_HOSTNAME,
  UI_DEV_ORIGIN,
  UI_HOST,
  UI_HOSTNAME,
  UI_HOST_ORIGINS,
  UI_ORIGIN,
  UI_ORIGINS,
  UI_PPE_HOST,
  UI_PPE_HOSTNAME,
  UI_PPE_ORIGIN,
  VIVACE_HOSTNAME,
  VIVACE_INT_HOSTNAME,
  expui_web_dev_wus_host,
  expui_web_dev_wus_hostname,
  expui_web_dev_wus_origin,
  expui_web_prod_wus_staging_host,
  expui_web_prod_wus_staging_hostname,
  expui_web_prod_wus_staging_origin
};
//# sourceMappingURL=Host.constants.js.map
